(function () {
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatNumber(cents, precision, thousands, decimal) {
    if (isNaN(cents) || cents == null) { cents = 0; }
    var amount = (cents / 100.0).toFixed(precision);
    var parts = amount.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var frac = parts[1] ? decimal + parts[1] : '';
    return whole + frac;
  }

  function initEtSspg(root) {
    var tiers = [];
    for (var i = 1; i <= 4; i++) {
      var qRaw = root.getAttribute('data-t' + i + '-q');
      var rRaw = root.getAttribute('data-t' + i + '-r');
      var q = parseInt(qRaw, 10);
      if (!isNaN(q) && q > 0 && rRaw) {
        tiers.push({ qty: q, reward: rRaw });
      }
    }
    tiers.sort(function (a, b) { return a.qty - b.qty; });

    if (tiers.length === 0) { root.style.display = 'none'; return; }

    var msgEl = root.querySelector('[data-et-sspg-message]');
    var fillEl = root.querySelector('[data-et-sspg-fill]');
    var tplPre = root.getAttribute('data-msg-pretier') || 'Add [count] more to unlock [reward].';
    var tplSuccess = root.getAttribute('data-msg-success') || "You've unlocked [reward]!";
    var tplGift = root.getAttribute('data-msg-gift') || 'Add [amount] more to unlock a free gift!';
    var tplGiftSuccess = root.getAttribute('data-msg-gift-success') || "You've unlocked a free gift!";
    var giftThresholdCents = parseInt(root.getAttribute('data-gift-threshold-cents'), 10) || 0;
    var moneyFormat = root.getAttribute('data-money-format') || '€{{amount_with_comma_separator}}';

    function formatMoney(cents) {
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var match = moneyFormat.match(placeholderRegex);
      if (!match) { return moneyFormat; }
      var value;
      switch (match[1]) {
        case 'amount':                                  value = formatNumber(cents, 2, ',', '.'); break;
        case 'amount_no_decimals':                      value = formatNumber(cents, 0, ',', '.'); break;
        case 'amount_with_comma_separator':             value = formatNumber(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = formatNumber(cents, 0, '.', ','); break;
        case 'amount_with_space_separator':             value = formatNumber(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': value = formatNumber(cents, 0, ' ', '');  break;
        case 'amount_with_period_and_space_separator':  value = formatNumber(cents, 2, ' ', '.'); break;
        case 'amount_with_apostrophe_separator':        value = formatNumber(cents, 2, "'", '.'); break;
        default:                                        value = formatNumber(cents, 2, ',', '.');
      }
      return moneyFormat.replace(placeholderRegex, value);
    }

    function render(count, totalCents) {
      var maxQty = tiers[tiers.length - 1].qty;
      var nextTier = null;
      for (var j = 0; j < tiers.length; j++) {
        if (tiers[j].qty > count) { nextTier = tiers[j]; break; }
      }

      var html;
      if (nextTier) {
        var pct = Math.min(100, Math.max(0, (count / maxQty) * 100));
        if (fillEl) { fillEl.style.width = pct + '%'; }
        var remaining = nextTier.qty - count;
        html = escapeHtml(tplPre)
          .replace(/\[count\]/g, '<strong class="et-sspg__count">' + remaining + '</strong>')
          .replace(/\[reward\]/g, '<span class="et-sspg__accent">' + escapeHtml(nextTier.reward) + '</span>');
      } else if (giftThresholdCents > 0 && totalCents < giftThresholdCents) {
        var giftPct = Math.min(100, Math.max(0, (totalCents / giftThresholdCents) * 100));
        if (fillEl) { fillEl.style.width = giftPct + '%'; }
        var remainingCents = giftThresholdCents - totalCents;
        html = escapeHtml(tplGift)
          .replace(/\[amount\]/g, '<span class="et-sspg__accent">' + escapeHtml(formatMoney(remainingCents)) + '</span>');
      } else if (giftThresholdCents > 0 && totalCents >= giftThresholdCents) {
        if (fillEl) { fillEl.style.width = '100%'; }
        html = escapeHtml(tplGiftSuccess);
      } else {
        if (fillEl) { fillEl.style.width = '100%'; }
        html = escapeHtml(tplSuccess)
          .replace(/\[reward\]/g, '<span class="et-sspg__accent">' + escapeHtml(tiers[tiers.length - 1].reward) + '</span>');
      }
      if (msgEl) { msgEl.innerHTML = html; }
    }

    root.__etSspgRender = render;

    render(
      parseInt(root.getAttribute('data-current-count'), 10) || 0,
      parseInt(root.getAttribute('data-current-total'), 10) || 0
    );
  }

  function scanAndInit() {
    var roots = document.querySelectorAll('[data-et-sspg-root]:not([data-et-sspg-init])');
    for (var i = 0; i < roots.length; i++) {
      var r = roots[i];
      r.setAttribute('data-et-sspg-init', '1');
      initEtSspg(r);
    }
  }

  function refreshAllFromServer() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var count = c.item_count || 0;
        var total = c.total_price || 0;
        var all = document.querySelectorAll('[data-et-sspg-root]');
        for (var i = 0; i < all.length; i++) {
          if (typeof all[i].__etSspgRender === 'function') {
            all[i].__etSspgRender(count, total);
          }
        }
      })
      .catch(function () {});
  }

  function setup() {
    if (window.__etSspgInit) { scanAndInit(); return; }
    window.__etSspgInit = true;

    scanAndInit();

    var scheduled = false;
    function schedule() {
      if (scheduled) { return; }
      scheduled = true;
      Promise.resolve().then(function () {
        scheduled = false;
        scanAndInit();
      });
    }

    var observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('cart:item-added', refreshAllFromServer);
    document.addEventListener('line-item:change:end', refreshAllFromServer);
    document.addEventListener('cart:refresh', refreshAllFromServer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
